// The Cockpit pages a message of LAMP's sends the person to (#1016): "Open it on the GST and compliance page" names the
// page by its title, never by a path. Web chat shows a link to each page named; Telegram shows the words as they are.
import { en } from "../i18n/en.js";
import { PAGE_IDS, PAGES, type Page } from "../shell/nav.js";

/** The pages `text` names as “the <title> page”, each once, in the Cockpit's order. */
export function pagesNamedIn(text: string): Page[] {
  return PAGE_IDS.filter((page) => text.includes(`the ${en[PAGES[page].title]} page`));
}
